import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import ArrowUpOnSquareIcon from "@heroicons/react/24/solid/ArrowUpOnSquareIcon";
import {
  Box,
  Button,
  Container,
  Stack,
  SvgIcon,
  Typography,
} from "@mui/material";
import { CustomersSearch } from "@/sections/customer/customers-search";
import { useGetHeroModelQuery } from "@/app/features/HeroModel/HeroModelApiSlice";
import HeroModelModal from "./components/HeroModel";
import HeroModelListing from "./components/HeroModelListing";

export default function HeroModelPage() {
  const [search, setSearch] = useState("");
  const [paginationModel, setPaginationModel] = useState({
    pageSize: 100,
    page: 0,
  });
  const { data, isLoading, isFetching, error } = useGetHeroModelQuery({
    page: paginationModel.page + 1,
    limit: paginationModel.pageSize,
    search: search,
  });

  const [rowCountState, setRowCountState] = useState(data?.count || 0);

  const [selectedHeroModel, setselectedHeroModel] = useState({});
  const [isHeroModelModalOpen, setisHeroModelModalOpen] = useState(false);

  const handleSelectedHeroModelModalClose = () => {
    setisHeroModelModalOpen(false);
  };

  const handleSelectHeroModel = (HeroModel) => {
    setselectedHeroModel(HeroModel);
    setisHeroModelModalOpen(true);
  };

  useEffect(() => {
    setRowCountState((prevRowCountState) =>
      data?.data?.total !== undefined ? data?.data?.total : prevRowCountState
    );
  }, [data, isLoading]);

  return (
    <Box
      component="main"
      sx={{
        flexGrow: 1,
        py: 8,
      }}
    >
      {selectedHeroModel && (
        <HeroModelModal
          open={isHeroModelModalOpen}
          handleClose={handleSelectedHeroModelModalClose}
          selectedHeroModel={selectedHeroModel}
        />
      )}

      <Container maxWidth="xl">
        <Stack spacing={3}>
          <Stack direction="row" justifyContent="space-between" spacing={4}>
            <Typography variant="h4">Hero Model</Typography>
            <Button
              color="inherit"
              startIcon={
                <SvgIcon fontSize="small">
                  <ArrowUpOnSquareIcon />
                </SvgIcon>
              }
              variant="contained"
              component={Link}
              to="/hero-model/create"
            >
              Add
            </Button>
          </Stack>
          <CustomersSearch search={search} setSearch={setSearch} />
          <HeroModelListing
            isLoading={isLoading || isFetching}
            error={error}
            data={data?.data}
            rowCountState={rowCountState}
            paginationModel={paginationModel}
            setPaginationModel={setPaginationModel}
            handleSelectHeroModel={handleSelectHeroModel}
          />
        </Stack>
      </Container>
    </Box>
  );
}
